import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {Waypoint} from '@homeaway/react-unveil';
import {logExperiment} from '@homeaway/abacus-client-utils';

import {SearchFormContainer} from '../SearchForm';
import {getStickyHeight} from '../utils/search-form';
import {TESTS} from '../../../../utils/abacus';

import './StickySearchForm.less';

export function mapStateToProps({config}) {
    const {
        hasTouch,
        templateType: {isMultiDestination},
    } = config;
    return {hasTouch, isMultiDestination};
}

const wayPointClassName = 'StickyWaypoint';

function StickySearchForm({isMultiDestination, hasTouch}) {
    const [isSticky, setIsSticky] = useState(false);
    const [rootMargin, setRootMargin] = useState('0px 0px 0px 0px');
    const shouldOpenDatePicker = !isMultiDestination;
    const [isOpen, setIsOpen] = useState(shouldOpenDatePicker);
    const stickyRef = useRef(null);

    useEffect(() => {
        if (hasTouch) {
            const top = getStickyHeight(stickyRef);
            setRootMargin(`${top} 0px 0px 0px`);
        }
    }, [hasTouch]);

    const onEnter = () => {
        setIsSticky(false);
    };

    const onLeave = () => {
        logExperiment(TESTS.VRBO_LANDING_STICKY_SEARCHFORM);
        setIsSticky(true);
        setIsOpen(false);
    };

    const deviceType = hasTouch ? 'tablet' : 'desktop';
    const searchFormOverrideProps = {
        datesSettings: {
            isOpen,
        },
    };
    const stickySearchFormClasses = classNames(
        'StickySearchFormWrapper',
        `StickySearchFormWrapper--${deviceType}`,
        {
            'StickySearchFormWrapper--sticky': isSticky,
        }
    );

    const spaceHolderStyle = {
        height: isSticky ? getStickyHeight(stickyRef) : 0,
    };

    return (
        <>
            <Waypoint
                key={`rootMargin=${rootMargin}`}
                label="sticky-waypoint-top"
                onEnter={onEnter}
                onLeave={onLeave}
                rootMargin={rootMargin}
            >
                <div className={wayPointClassName} />
            </Waypoint>
            <div
                className={stickySearchFormClasses}
                ref={stickyRef}
                style={{top: '0px'}}
            >
                <SearchFormContainer
                    stickySearchFormDataOverrides={searchFormOverrideProps}
                />
            </div>
            <div style={spaceHolderStyle} />
        </>
    );
}

StickySearchForm.propTypes = {
    isMultiDestination: PropTypes.bool,
    hasTouch: PropTypes.bool,
};

StickySearchForm.defaultProps = {
    isMultiDestination: false,
    hasTouch: false,
};

export const StickySearchFormWrapper = connect(mapStateToProps)(
    StickySearchForm
);

StickySearchFormWrapper.displayName = 'StickySearchFormWrapper';
